import { render, staticRenderFns } from "./applySettlementAgency.vue?vue&type=template&id=6e0dc8cc"
import script from "./applySettlementAgency.vue?vue&type=script&lang=js"
export * from "./applySettlementAgency.vue?vue&type=script&lang=js"
import style0 from "./applySettlementAgency.vue?vue&type=style&index=0&id=6e0dc8cc&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports